// src/AppRoutes.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import FormPage from './pages/FormPage';

/**
 * Define as rotas principais da aplicação React
 * @returns {JSX.Element}
 */
const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<HomePage />} />
    <Route path="/login" element={<LoginPage />} />
    <Route path="/form" element={<FormPage />} />
  </Routes>
);

export default AppRoutes;
